import { render, staticRenderFns } from "./CarNew.vue?vue&type=template&id=2bc830f9&scoped=true&"
import script from "./CarNew.vue?vue&type=script&lang=ts&"
export * from "./CarNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc830f9",
  null
  
)

export default component.exports